import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';

// The sidebar search finds a load by its freight tracking ID or its external TMS ID, so either
// can open it. Accepted cards with no known load have neither.
export function getBuiltLoadIdentifier(
  suggestion: LoadBuildingSuggestions
): string {
  return (
    suggestion.builtLoad?.freightTrackingID?.trim() ||
    suggestion.builtLoad?.externalTMSID?.trim() ||
    ''
  );
}
